import PricingSection from '@/components/PricingSection';
import Footer from '@/components/Footer';

export default function PricingPage() {
  return (
    <div className="pt-20">
      <PricingSection />
      <Footer />
    </div>
  );
}
